export default __webpack_public_path__ + "static/media/bookmark.9aeb26d4.svg";